import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';
import { MatSnackBar, MatDatepickerInputEvent, MatDialogRef, MAT_DIALOG_DATA, MatAutocompleteTrigger } from '@angular/material';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CampaignService } from 'src/app/services/campaign/campaign.service';

@Component({
  selector: 'app-add-campaign',
  templateUrl: './add-campaign.component.html',
  styleUrls: ['./add-campaign.component.scss']
})
export class AddCampaignComponent implements OnInit {
  date = new Date();
  // nameExp = '[a-zA-Z0-9 ]*$';
  nameExp = '[a-zA-Z ]*$';
  digitExp = '^[0-9]*$';
  check: boolean = false;
  startDate = "";
  endDate = "";
  checkDefault: boolean = false;
  isCheckDefault: boolean = false;
  isPaid: boolean = false;
  target;
  endDateTime;
  startDateTime = new Date();
  purposeArray = ['REGISTER_ONLY', "MCQ_TEST", "REFERRAL"];
  purpose = 'REGISTER_ONLY';
  questionFormatId;
  campaignList = [];
  sourceArray = [];
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  listData: any;

  constructor(private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    private snackbar: MatSnackBar,
    private campaign: CampaignService,
    public dialogRef: MatDialogRef<AddCampaignComponent>,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.campaignList = data;

  }
  name = new FormControl(null, [Validators.required, Validators.minLength(2), this.noWhitespaceValidator]);
  source = new FormControl(null, [Validators.required, Validators.minLength(2), this.noWhitespaceValidator]);
  location = new FormControl(null, [Validators.required, Validators.minLength(2), this.noWhitespaceValidator]);
  company = new FormControl(null, [Validators.required, Validators.minLength(2), this.noWhitespaceValidator]);
  creatername = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp),
  Validators.minLength(2), this.noWhitespaceValidator]);
  address = new FormControl(null, [Validators.required, Validators.minLength(2), this.noWhitespaceValidator])
  startDatePicker = new FormControl(null, Validators.required);
  endDatePicker = new FormControl(null, Validators.required);
  message = new FormControl(null, [Validators.required, Validators.minLength(2), this.noWhitespaceValidator]);
  noOfAttempt = new FormControl(null, [Validators.required, Validators.pattern(this.digitExp)]);
  questionFormatIdList = [];
  activeQuestionFormatIdList = [];
  uniqueArray = [];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  sourceError: boolean = true;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.getTestFormatList();
    for (let i = 0; i < this.campaignList.length; i++) {
      this.sourceArray.push(this.campaignList[i].source);
    }
    this.uniqueArray = Array.from(new Set(this.sourceArray));
    console.log("uniqueArray", this.uniqueArray);
  }
  
  getCollegeList(campaignType: String): void {
    this.campaign.getListData(campaignType)
      .subscribe(response => {
        console.log(response);
        this.listData = (response as any).data;
  
      });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.uniqueArray.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  closeMatPanel() {
    console.log("closeMatPanel")
    if (this.myControl.value.length > 0) {
      this.autocomplete.closePanel();
    }
  }

  getErrorForName() {
    return this.name.hasError('required') ? ' Name can\'t be blank' :
      this.name.hasError('minlength') ? 'Name length should be greater than 1' :
        this.name.hasError('whitespace') ? 'Please provide valid name' : '';
  }
  getErrorForSource() {
    if (this.myControl.value != '' && this.myControl.value != null && this.myControl.value != undefined) {
      this.sourceError = true;
    }
    else {
      this.sourceError = false;
    }
  }

  getErrorForLocation() {
    return this.location.hasError('required') ? ' Location can\'t be blank' :
      this.location.hasError('minlength') ? 'Location length should be greater than 1' :
        this.location.hasError('whitespace') ? 'Please provide valid location' : '';
  }
  getErrorForCompany() {
    return this.company.hasError('required') ? 'Company can\'t be blank' : '';
  }
  getErrorForAddress() {
    return this.address.hasError('required') ? 'Address can\'t be blank' :
      this.address.hasError('minlength') ? 'Address length should be greater than 2' :
        this.address.hasError('whitespace') ? 'Please provide valid address' : '';
  }
  getErrorForCreaterName() {
    return this.creatername.hasError('required') ? ' Creater Name can\'t be blank' :
      this.creatername.hasError('pattern') ? 'Please provide valid name creater name' :
        this.creatername.hasError('minlength') ? 'Creater name length should be greater than 1' :
          this.creatername.hasError('whitespace') ? 'Please provide valid creater name' : '';
  }
  getErrorForStartDate() {
    return this.startDatePicker.hasError('required') ? 'Start date can\'t be blank' : '';
  }
  getErrorForEndDate() {
    return this.endDatePicker.hasError('required') ? 'End date can\'t be blank' : '';
  }

  getErrorForMessage() {
    return this.message.hasError('required') ? 'Interview message can\'t be blank' :
      this.message.hasError('minlength') ? 'Interview message length should be greater than 2' :
        this.message.hasError('whitespace') ? 'Please provide valid interview message' : '';
  }
  getErrorMessageForNoOfAttempt() {
    return this.noOfAttempt.hasError('required') ? 'Number of attempt can\'t be blank' :
      this.noOfAttempt.hasError('pattern') ? 'Number of attept can be numerical only' : '';

  }
  getElementByQuestionSetFormatName(name) {
    return this.activeQuestionFormatIdList.find(x => x.name == name)
  }
  closeDialog(flag: boolean): void {
    this.dialogRef.close(flag);
  }
  optionSelected(event) {
    if (event.option.value != "" && event.option.value != null) {
      this.sourceError = true;
    }
    else {
      this.sourceError = false;
    }
  }

  toggleButtonBasedOnPurpose(): boolean {
    if (this.purpose == 'REGISTER_ONLY') {
      if (this.address.value != "" && this.address.value != null && this.message.value != "" && this.message.value != null) {
        return false;
      }
      else {
        return true;
      }
    }
    else if (this.purpose == 'MCQ_TEST') {
      if (this.noOfAttempt.value != "" && this.noOfAttempt.value != null && this.questionFormatId != "" && this.questionFormatId != null) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      if (this.address.value != "" && this.address.value != null && this.message.value != "" && this.message.value != null) {
        return false;
      }
      else {
        return true;
      }
    }
  }


  addCampaign() {
    var data;
    if (this.purpose == 'MCQ_TEST') {
      if (this.noOfAttempt.value > 0) {
        data = {
          name: this.name.value.trim(),
          source: this.myControl.value.trim(),
          location: this.location.value.trim(),
          creatorName: this.creatername.value.trim(),
          purpose: this.purpose.trim(),
          maxAttemptCount: this.noOfAttempt.value.trim(),
          paid: this.isPaid,
          default: this.isCheckDefault,
          startDate: this.startDate,
          endDate: this.endDate,
          questionSetFormatId: this.getElementByQuestionSetFormatName(this.questionFormatId).id
        }

        console.log("Campaign Data", data);
        this.spinnerService.show();
        var contentBody = { url: "/campaigns", body: data }
        this.httpService.httpPost(contentBody, true).subscribe(response => {
          console.log("success ", response);
          this.openSnackBar(response["message"]);
          this.spinnerService.hide();
          this.closeDialog(true);
        }, error => {
          console.log("error ", error);
          this.spinnerService.hide();
          this.openSnackBar(error.error.message);
        })
      }
      else {
        this.openSnackBar("Provide valid data")
      }
    }
    else {
      data = {
        name: this.name.value.trim(),
        source: this.myControl.value.trim(),
        location: this.location.value.trim(),
        creatorName: this.creatername.value.trim(),
        interviewAddress: this.address.value.trim(),
        interviewMessage: this.message.value.trim(),
        purpose: this.purpose.trim(),
        paid: this.isPaid,
        default: this.isCheckDefault,
        startDate: this.startDate,
        endDate: this.endDate,
      }

      console.log("Campaign Data", data);
      this.spinnerService.show();
      var contentBody = { url: "/campaigns", body: data }
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log("success ", response);
        this.openSnackBar(response["message"]);
        this.spinnerService.hide();
        this.closeDialog(true);
      }, error => {
        console.log("error ", error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
  }

  isPaidChecked(event) {
    this.isPaid = event.checked;
  }
  isPaidChecked1(event) {
    this.isCheckDefault = event.checked;
  }
  radioChange(event) {
    this.target = event.value;
  }
  addEvent(event: MatDatepickerInputEvent<Date>) {
    console.log("event", event.value);
    this.startDateTime = event.value;
    var date = this.convertDate(event.value);
    this.startDate = date;
  }
  addEvent1(event: MatDatepickerInputEvent<Date>) {
    console.log("event", event.value);
    this.endDateTime = event.value;
    var date = this.convertDate(event.value);
    this.endDate = date;
  }
  convertDate(dateToConvert) {
    var dateObj = new Date(dateToConvert);
    var month = dateObj.getMonth() + 1;
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    let date = year + '-' + month + '-' + day;
    return date;
  }

  getTestFormatList() {
    this.activeQuestionFormatIdList = []
    this.spinnerService.show();
    var contentBody = { url: '/questionsetformats' }
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log('respose questionsetformats', response);
      this.questionFormatIdList = response;
      for (let i = 0; i < this.questionFormatIdList.length; i++) {
        if (this.questionFormatIdList[i].status === 'ACTIVE') {
          this.activeQuestionFormatIdList.push(this.questionFormatIdList[i]);
        }
      }
      console.log("activeQuestionFormatIdList", this.activeQuestionFormatIdList);
      this.spinnerService.hide();

    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message)
    })
  }
  openSnackBar(message: string) {
    this.snackbar.open(message, null, {
      duration: 2000,
    });
  }
}
